import React from 'react';
import { MiniLoader } from '@pwc/pwc-deals-ui';
import './ProjectLoader.scss';

const ProjectLoader = () => {
  return (
    <div className="project-loader-spinner">
      <MiniLoader dataTestId="project-loader-spinner" />
    </div>
  );
};

export default ProjectLoader;
